import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import { Icon } from '@iconify/react/dist/iconify.js';
import GlobalDialog from '../mui/Dialogue/GlobalDialog';
import { getFileType } from './utils/uploadFunctions';

const GlobalAllTypeFileView = ({ attachmentFiles = [], previewButtonName }) => {
  const [open, setOpen] = React.useState(false);

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <GlobalDialog
      maxWidth="md"
      fullWidth
      open={open}
      setOpen={setOpen}
      closeButton
      closeCondition={handleCancel}
      popupButton={
        <Button
          disabled={!attachmentFiles?.length}
          size="small"
          color="info"
          variant="outlined"
          onClick={() => setOpen(true)}
        >
          <Icon icon="carbon:view-filled" width="20" height="18" />
          {previewButtonName || ''}
        </Button>
      }
      content={
        <Stack sx={{ height: '70vh', width: '100%' }} gap={2}>
          {!attachmentFiles?.length ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                fontSize: 18,
                color: 'gray',
                fontWeight: 500,
              }}
            >
              No Attachment Available
            </Box>
          ) : (
            attachmentFiles?.map((name, i) => {
              const fileType = getFileType(name); // type
              const fileUrl = `${process.env.REACT_APP_CONTABO_UPLOADS_BASE_URL}/${name}`;

              if (fileType === 'pdf') {
                return (
                  <iframe
                    key={i}
                    src={fileUrl}
                    width="100%"
                    height="100%"
                    title="Uploaded PDF"
                    style={{ border: 'none', borderRadius: 4, minHeight: '100%' }}
                  />
                );
              }

              if (fileType === 'video') {
                return (
                  <video
                    key={i}
                    src={fileUrl}
                    controls
                    style={{
                      width: '100%',
                      height: '100%',
                      borderRadius: 4,
                      backgroundColor: '#000',
                    }}
                  />
                );
              }

              if (fileType === 'audio') {
                return (
                  <Box
                    key={i}
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    <audio src={fileUrl} controls style={{ width: '80%' }} />
                  </Box>
                );
              }

              return (
                <img
                  key={i}
                  src={fileUrl}
                  alt="Uploaded File"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    borderRadius: 4,
                    border: '1px solid #ccc',
                  }}
                />
              );
            })
          )}
        </Stack>
      }
    />
  );
};

export default GlobalAllTypeFileView;
